import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { Typography } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  badge:  {
    padding:        '1px 5px',
    maxWidth:       100,
    overflow:       'hidden',
    textOverflow:   'ellipsis',
    height:         18,
    borderRadius:   2,
    color:          '#FFF',
    fontFamily:     'Roboto',
    fontSize:       10,
    display:        'inline-block',
    justifyContent: 'center',
    alignItems:     'center',
    letterSpacing:  '1.5px',
    textTransform:  'uppercase',
    fontWeight:     500,
    marginRight:    theme.spacing()
  },
  black: {
    backgroundColor: 'var(--primary)'
  },
  purple: {
    backgroundColor: 'var(--tertiary-purple)'
  },
  green:  {
    backgroundColor: 'var(--tertiary-green)'
  },
  red:    {
    backgroundColor: 'var(--tertiary-red)'
  },
  pink:   {
    backgroundColor: '#ff99c1'
  },
  yellow: {
    backgroundColor: 'var(--tertiary-yellow)'
  }
})

interface MyProps extends StyledProps {
  color: string,
  badge: string,
}
export class BadgeComponent extends React.Component<MyProps> {
  static defaultProps = {
    color: 'purple',
    badge: 'badge'
  }

  render() {
    const {color, badge, classes} = this.props
    return (
      <Typography variant={'caption'} classes={{caption: classes.badge}} className={classes[color]}>{badge}</Typography>
    )
  }
}
@(withStyles as any)(styles)
export class Badge extends BadgeComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Badge.tsx